module.exports = __webpack_public_path__ + "static/img/6-1.e7b50a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/335/6-1.jpg
// module id = 3bb9
// module chunks = 0